import { FC, useState } from 'react'

/** A freshly issued set: the only time the codes are visible. */
export const RecoveryCodes: FC<{ codes: string[]; onDismiss: () => void }> = ({ codes, onDismiss }) => {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(codes.join('\n'))
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }

  return (
    <div className='alert alert-primary d-flex flex-column gap-4'>
      <div className='fw-bold'>
        Сохраните резервные коды: они больше не будут показаны. Код подходит для входа вместо кода из
        приложения, пока вы не выпустите новый набор.
      </div>
      <div className='d-flex flex-wrap gap-3 font-monospace fs-5'>
        {codes.map((code) => (
          <span key={code} className='px-3 py-1 rounded border border-primary bg-body'>
            {code}
          </span>
        ))}
      </div>
      <div className='d-flex gap-3'>
        <button type='button' className='btn btn-sm btn-primary' onClick={copy}>
          {copied ? 'Скопировано' : 'Скопировать'}
        </button>
        <button type='button' className='btn btn-sm btn-light' onClick={onDismiss}>
          Я сохранил коды
        </button>
      </div>
    </div>
  )
}
